
<span class="summary-highlight-text" [attr.data-testid]="'confirmation-room-details-adults'">{{roomInfo.searchMask.adults}} </span> @if (roomInfo.searchMask.adults > 1) {{{"pr.adults"|translate}}}@else{{{"pr.adult"|translate}}}@if(roomInfo.searchMask.children > 0){,
<span class="summary-highlight-text" [attr.data-testid]="'confirmation-room-details-children'">{{roomInfo.searchMask.children}} </span> @if (roomInfo.searchMask.children == 1) {{{"pr.child"|translate}}}@else{{{"pr.children"|translate}}} }


<div class="room-details-container" [attr.data-testid]="'confirmation-room-details'">
    <div class="row">
        <div class="col-12 col-md-4 d-print-none">
            <app-image-gallery1 [roomCode]="roomInfo.roomRate.room.roomCode" [hotelCode]="roomInfo.hotelId"></app-image-gallery1>
        </div>
        <div class="col-12 col-md-8">
            <div class="room-details-data">
                @if (isMultiRoomBooking) {
                    <div class="row">
                        <div class="col-4 col-sm-3">{{"cn.confirmationNumber"|translate}}</div>
                        <div class="col-8 col-sm-9 res-id-value">{{roomInfo.reservationId}}</div>
                    </div>
                }


                <div class="row">
                    <div class="col-4 col-sm-3">{{'cn.Name' | translate}}</div>
                    <div class="col-8 col-sm-9">{{roomInfo.bookerProfile.firstName }} {{roomInfo.bookerProfile.lastName }}</div>
                </div>

                @if (roomInfo.bookerProfile.companyName) {
                    <div class="row" [attr.data-testid]="'confirmation-company-name'">
                        <div class="col-4 col-sm-3">{{'pr.companyName' | translate}}</div>
                        <div class="col-8 col-sm-9">{{roomInfo.bookerProfile.companyName}}</div>
                    </div>
                }

                <div class="row">
                    <div class="col-4 col-sm-3">{{'cn.Email' | translate}}</div>
                    <div class="col-8 col-sm-9">{{roomInfo.bookerProfile.emails[0] }}</div>
                </div>

                <div class="row">
                    <div class="col-4 col-sm-3">{{'cn.Phone' | translate}}</div>
                    <div class="col-8 col-sm-9">{{roomInfo.bookerProfile.mobilePhoneNumber }}</div>
                </div>

                <div class="row">
                    <div class="col-4 col-sm-3">{{'cn.Address' | translate}}</div>
                    <div class="col-8 col-sm-9">{{roomInfo.bookerProfile.addressLine1 }}<br>{{roomInfo.bookerProfile.postalCode}} {{roomInfo.bookerProfile.city}}, {{countryList && getCountryName(roomInfo.bookerProfile.countryISO)}}</div>
                </div>


                <div class="row">
                    <div class="col-4 col-sm-3">{{'cn.Room' | translate}}</div>
                    <div class="col-8 col-sm-9"><b>{{roomInfo.roomRate.room.pim?.name }}</b><br><span class="common-details-room-short-desc" [innerHTML]="roomInfo.roomRate.room.pim?.shortDescription"></span></div>
                </div>

                <div class="row">
                    <div class="col-4 col-sm-3">{{'cn.Rate' | translate}}</div>
                    <div class="col-8 col-sm-9"><b>{{roomInfo.roomRate|formatRateName}}</b><br><span class="common-details-rate-short-desc" [innerHTML]="roomInfo.roomRate.rate.pim?.rateDescription"></span></div>
                </div>

                <div class="row">
                    <div class="col-4 col-sm-3">{{'cn.RoomPrice' | translate}}</div>
                    <div class="col-8 col-sm-9"><div class="room-price-highlight" [innerHTML]="onlyRoomPrice|currency"></div></div>
                </div>
                @if (roomInfo.extras && roomInfo.extras.length > 0) {
                    <div class="row" [attr.data-testid]="'confirmation-room-details-extras'">
                        <div class="col-4 col-sm-3">{{'cn.Extras' | translate}}</div>
                        <div class="col-8 col-sm-9">
                            @for (extra of roomInfo.extras; track $index) {
                                {{extra.quantity}} x {{extra.pim?.name ?? extra.extraName |stripTags}}: <span class="extra-price" [innerHTML]="extra.totalPriceForStayWithTaxes|currency"></span><br>
                            }
                            @if (hasExternalExtras) {
                                <p-message styleClass="mt-2">{{'cn.exteralExtrasNotification'|translate}}</p-message>
                            }
                        </div>
                    </div>
                }

                <div class="row">
                    <div class="col-4 col-sm-3" [attr.data-testid]="'confirmation-room-details-price'">{{'cn.Price' | translate}}</div>
                    <div class="col-8 col-sm-9"><div class="price-highlight" [innerHTML]="roomInfo.totalPriceForStayWithTaxes|currency" [attr.data-testid]="'confirmation-room-details-total'"></div></div>
                </div>

                @if (roomInfo.roomRate.rate.pim?.cancellationPolicy) {
                    <div class="row">
                        <div class="col-4 col-sm-3">{{'cn.cancellationPolicy' | translate}}</div>
                        <div class="col-8 col-sm-9"><span class="common-details-cancellation-policy" [innerHTML]="roomInfo.roomRate.rate.pim?.cancellationPolicy"></span></div>
                    </div>
                }

            </div>
        </div>
    </div>
</div>
